import { OtpId } from 'model/modules/otp/types';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const loginApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    checkOtp: builder.mutation<AuthSID, ApiCheckOtpRequestData>({
      query: (data: ApiCheckOtpRequestData) => ({
        url: '/v3/auth/check',
        method: 'POST',
        body: data,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiCheckOtpResponseData>
      ) {
        return baseQueryReturnValue.data.sid;
      },
    }),
    checkPhone: builder.mutation<OtpId, CheckPhoneRequestData>({
      query: (data: CheckPhoneRequestData) => ({
        url: '/v3/auth/create',
        method: 'POST',
        body: data,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<CheckPhoneResponseData>
      ) {
        return baseQueryReturnValue.data.otp_id;
      },
    }),
    logout: builder.mutation<SharesproApiResponse<boolean>, void>({
      query: () => ({
        url: '/v3/auth/logout',
        method: 'GET',
        sendToken: true,
      }),
    }),
  }),
});

export const { useCheckOtpMutation, useCheckPhoneMutation, useLogoutMutation } =
  loginApi;
